// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-header {
  margin-bottom: 16px;
}

.BrandedBorderColorFocus-Input {
  margin-bottom: 8px;
}
.BrandedBorderColorFocus-Input textarea {
  width: 100%;
}

.error {
  color: var(--fi-color-red);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-text-editor/fi-text-editor-insert-embed-video/text-editor-insert-embed-video-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;AADI;EACI,WAAA;AAGR;;AACA;EACI,0BAAA;AAEJ","sourcesContent":[".content-header {\r\n    margin-bottom: 16px;\r\n}\r\n.BrandedBorderColorFocus-Input {\r\n    margin-bottom: 8px;\r\n    textarea {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.error {\r\n    color: var(--fi-color-red);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
